import * as PhysicianConstants from '../constants/Physicians';
import {Physician} from '../../../models/Physician';


interface PhysicianState {
  error: boolean;
  isLoading: boolean;
  collection: Physician[];
}

const initialState: PhysicianState = {
  collection: [],
  isLoading: false,
  error: null
};

export function physicians(state = initialState, action) {
  switch (action.type) {
    case PhysicianConstants.PHYSICIAN_FETCH_STARTED:
      return Object.assign({}, state, {isLoading: true});
    case PhysicianConstants.PHYSICIAN_FETCH_COMPLETED:
      return Object.assign({}, state, {collection: action.physicians, error: null, isLoading: false});
    case PhysicianConstants.PHYSICIAN_FETCH_FAILED:
      return Object.assign({}, state, {isLoading: false, error: action.error});
    default:
      return state;
  }
}
